import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import IDCopy from "./IDCopy"

const Container = styled.div`
  padding: 0.5rem 0;
`

const Name = styled.h2`
  margin: 0;
  font-size: 2rem;
`

const ID = styled.span`
  margin: 0;
  font-size: 1rem;
`

/** NameIDHeader is a standard page- or block-level header for something with
 * a name and an ID. */
const NameIDHeader = ({ name, id }) => (
  <Container>
    {name && <Name>{name}</Name>}
    {id && (
      <ID>
        <IDCopy id={id} showCopy />
      </ID>
    )}
  </Container>
)

NameIDHeader.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
}

export default NameIDHeader
